export const shouldAuthenticate = (location: Location) =>
  /access_token|id_token|error|code=/.test(location.hash) || /code=|error=/.test(location.search);
